module.exports = __webpack_public_path__ + "img/weix.c145f62c.png";